module.exports = __webpack_public_path__ + "static/media/header-375.ea853c0d.webp";